import { render, staticRenderFns } from "./choiceTree.vue?vue&type=template&id=4b09c2a4&scoped=true&"
import script from "./choiceTree.vue?vue&type=script&lang=js&"
export * from "./choiceTree.vue?vue&type=script&lang=js&"
import style0 from "./choiceTree.vue?vue&type=style&index=0&id=4b09c2a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b09c2a4",
  null
  
)

export default component.exports